import { render, staticRenderFns } from "./TableEditorDialog.vue?vue&type=template&id=02068964"
import script from "./TableEditorDialog.vue?vue&type=script&lang=js"
export * from "./TableEditorDialog.vue?vue&type=script&lang=js"
import style0 from "./TableEditorDialog.vue?vue&type=style&index=0&id=02068964&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports